import React from 'react';
import { ActivityIndicator, Pressable } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

import { ThemedText } from '@/components/themed-text';
import { TEST_TOOLS_ENABLED } from '@/utils/test-tools';

/**
 * PaymentMethod de teste do Stripe (Visa 4242…) — só funciona com `pk_test_`.
 * O Payment Element é um iframe e o PaymentSheet é nativo: não dá para
 * preencher os campos por código, então o atalho de dev confirma o
 * PaymentIntent direto com este cartão.
 */
export const DEV_TEST_PAYMENT_METHOD = 'pm_card_visa';

/** Só com `EXPO_PUBLIC_TEST_TOOLS` e com chave de teste. */
export function isDevTestCardEnabled(publishableKey: string | null | undefined): boolean {
  return TEST_TOOLS_ENABLED && !!publishableKey?.startsWith('pk_test_');
}

/** Mesmo visual do "Preencher com dados de teste" da ativação. */
export function DevTestCardButton({ onPress, busy }: { onPress: () => void; busy?: boolean }) {
  return (
    <Pressable
      onPress={onPress}
      disabled={busy}
      className="h-9 flex-row items-center gap-2 self-start rounded-full border border-dashed border-neutral-300 px-3"
      testID="checkout-dev-test-card"
    >
      {busy ? (
        <ActivityIndicator size="small" color="#737373" />
      ) : (
        <Ionicons className="text-neutral-500" name="flask-outline" size={14} />
      )}
      <ThemedText className="text-xs text-neutral-600">Pagar com cartão de teste</ThemedText>
    </Pressable>
  );
}
